import { browserClasses } from "./browsers";

export function setPageClasses() {
  const html = document.documentElement;
  let newClasses = document.location.pathname.split("/").filter(str => str != "");

  if (newClasses.length === 0) {
    newClasses.push("home");
  }
  else if (newClasses.length === 1) {
  }
  else if (newClasses.length === 2) {
  }

  newClasses = [...newClasses, ...browserClasses()];

  // Determine and only change the differences
  const removeClasses = [...html.classList].filter(name => !newClasses.includes(name));
  const addClasses = newClasses.filter(name => !html.classList.contains(name));

  html.classList.remove(...removeClasses);
  html.classList.add(...addClasses);
}
